import { FC } from 'react';

import { LinkButton } from '@eluve/components';

type OpenInReviewButtonProps = {
  appointmentId: string;
  tenantId: string;
};

export const OpenInReviewButton: FC<OpenInReviewButtonProps> = ({
  appointmentId,
  tenantId,
}) => {
  const url = `/review/appointments/${tenantId}/${appointmentId}`;

  return (
    <LinkButton
      icon={{ name: 'UserRoundSearch' }}
      text="Open in Review Dashboard"
      to={url}
      type="outline"
    />
  );
};
